// extracted by mini-css-extract-plugin
export default {"name":"AccountName_name__fz5D5","role":"AccountName_role__Xc3qo","admin":"AccountName_admin__ZwT-v"};